import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/HomePage.css';

const HomePage: React.FC = () => {
  return (
    <div className="home-container">
      <section className="hero-section">
        <div className="hero-copy">
          <span className="eyebrow">Certificate Operations</span>
          <h1>Issue, download, and verify certificates in one workspace.</h1>
          <p className="hero-subtitle">
            Generate polished PDF certificates with QR verification, then confirm authenticity from any device.
          </p>
          <div className="hero-actions">
            <Link to="/create" className="btn btn-primary btn-large">
              Create Certificate
            </Link>
            <Link to="/verify" className="btn btn-secondary btn-large">
              Verify Certificate
            </Link>
          </div>
        </div>

        <div className="hero-panel" aria-label="Certificate workflow summary">
          <div className="panel-row">
            <span className="panel-kicker">PDF status</span>
            <strong>Ready after creation</strong>
          </div>
          <div className="panel-row">
            <span className="panel-kicker">Verification</span>
            <strong>QR and certificate number</strong>
          </div>
          <div className="panel-row">
            <span className="panel-kicker">Access</span>
            <strong>Admin download secured</strong>
          </div>
        </div>
      </section>

      <section className="quick-actions" aria-label="Primary actions">
        <Link to="/create" className="action-card">
          <span className="action-icon">+</span>
          <strong>Create certificates</strong>
          <p>Enter company, certification, and validity details.</p>
        </Link>
        <Link to="/verify" className="action-card">
          <span className="action-icon">?</span>
          <strong>Verify authenticity</strong>
          <p>Search by number or scan a QR code from a certificate.</p>
        </Link>
        <div className="action-card">
          <span className="action-icon">PDF</span>
          <strong>Download PDFs</strong>
          <p>Download generated PDFs immediately after creation or from verified details while signed in.</p>
        </div>
      </section>

      <section className="info-section">
        <div className="info-card">
          <h2>Workflow</h2>
          <div className="steps">
            <div className="step">
              <span className="step-number">1</span>
              <div>
                <h4>Create</h4>
                <p>Fill the certificate form and submit it securely.</p>
              </div>
            </div>
            <div className="step">
              <span className="step-number">2</span>
              <div>
                <h4>Download</h4>
                <p>Use the generated PDF file with its QR code.</p>
              </div>
            </div>
            <div className="step">
              <span className="step-number">3</span>
              <div>
                <h4>Verify</h4>
                <p>Confirm status, expiry, and certificate details.</p>
              </div>
            </div>
          </div>
        </div>

        <div className="info-card">
          <h2>Status Guide</h2>
          <div className="status-info">
            <div className="status-item">
              <span className="status-badge valid">Valid</span>
              <p>Certificate is active and within its validity period.</p>
            </div>
            <div className="status-item">
              <span className="status-badge expired">Expired</span>
              <p>The expiry date has passed.</p>
            </div>
            <div className="status-item">
              <span className="status-badge suspended">Suspended</span>
              <p>The certificate has been revoked or suspended.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
